import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiKey } from "../config/config";
import { toast } from "react-toastify";

function InvestorDepositWithdraw({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin
  )?.branch_id;
  const { id, process } = useParams();
  const [formData, setFormData] = useState({
    investor: id,
    investor_name: "",
    bank_account: "",
    amount: "",
    balanceBefore: "",
    balanceAfter: "",
    statement: "",
    branch_id: branchId,
  });
  const [accountList, setAccountList] = useState([]);

  const navigate = useNavigate();

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (process === "deposit") {
      axios
        .put(
          `${apiKey}/investor-amount-deposit/${formData.investor}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          toast.success(res.data.Message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error("Some error occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    } else {
      axios
        .put(
          `${apiKey}/investor-amount-withdraw/${formData.investor}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          toast.success(res.data.Message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate(-1);
        })
        .catch((err) => {
          toast.error("Some error occured", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        });
    }
  };

  useEffect(() => {
    axios
      .get(apiKey + "/get-accounts", {
        params: {
          branch_id: branchId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setAccountList(res.data.result);
      })
      .catch((err) => {
        console.error(err);
      });

    axios
      .get(`${apiKey}/investor-get/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setFormData((prev) => ({
          ...prev,
          balanceBefore: res.data?.result[0]?.balance,
          investor_name: res.data?.result[0]?.FullName,
        }));
      });
  }, [branchId, id, token]);

  useEffect(() => {
    if (process === "deposit") {
      setFormData((prevData) => ({
        ...prevData,
        balanceAfter:
          parseFloat(prevData.balanceBefore || 0) +
          parseFloat(prevData.amount || 0),
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        balanceAfter:
          parseFloat(prevData.balanceBefore || 0) -
          parseFloat(prevData.amount || 0),
      }));
    }
  }, [formData.balanceBefore, formData.amount, process]);

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>
          {lang.Investment_Loan_Management || "Investment/Loan Management"}
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">
              {lang.Investment_Loan_Management || "Investment/Loan Management"}
            </li>
            <li className="breadcrumb-item active">
              {process === "deposit"
                ? lang.Deposit_Process || "Deposit Process"
                : lang.Withdraw_Process || "Withdraw Process"}
            </li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="d-flex-my-3">
                  <h4 className="headingh4 fw-bold">
                    {process === "deposit"
                      ? lang.Deposit_Process || "Deposit Process"
                      : lang.Withdraw_Process || "Withdraw Process"}
                  </h4>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="d-flex gap-4 justify-content-end my-3">
                    <button type="submit" className="btn-cancel">
                      {lang.Save || "Save"}
                    </button>
                    <button type="button" className="btn-save">
                      {lang.Cancel || "Cancel"}
                    </button>
                  </div>
                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Investor || "Investor"}:
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          readOnly
                          value={formData.investor_name}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      {/* Bind input fields to state variables */}
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Account_for_Payments || "Account for Payments"}:
                        </span>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          onChange={handleChange}
                          name="bank_account"
                          required
                        >
                          <option selected disabled>
                            {lang.Account_for_Payments ||
                              "Account for payments"}
                          </option>
                          {accountList.map((account) => (
                            <option
                              key={account.id}
                              value={account.account_number}
                            >
                              {account.account_name}
                            </option>
                          ))}
                        </select>
                      </label>
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Amount || "Amount"}:
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="amount"
                          value={formData.amount}
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Balance_Before || "Balance Before"}:
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="balanceBefore"
                          value={formData.balanceBefore}
                          readOnly // Make this field read-only
                        />
                      </label>
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      <label htmlFor="" className="w-100">
                        <span style={{ fontSize: "14px" }}>
                          {lang.Balance_After || "Balance After"}:
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          value={formData.balanceAfter}
                          name="balanceAfter"
                          onChange={handleChange}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="row mb-3 d-flex justify-content-center">
                    <div className="col-lg-4">
                      <label htmlFor="" className="w-100"></label>
                      <span style={{ fontSize: "14px" }}>
                        {lang.Note || "Note"}:
                      </span>
                      <textarea
                        className="form-control"
                        rows="5"
                        name="statement"
                        value={formData.statement}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default InvestorDepositWithdraw;
